// Native & external imports
import {
  Directive,
  HostListener,
  EventEmitter,
  Output,
  inject,
} from "@angular/core";
import { FileHandle } from "src/objects/file-handle.interface";
import { DomSanitizer } from "@angular/platform-browser";
@Directive({
  standalone: false,
  selector: "[cmpAppImageDrag]",
})
export class ImageDragDirective {
  private sanitizer = inject(DomSanitizer);

  @Output() files: EventEmitter<FileHandle[]> = new EventEmitter();
  @HostListener("dragover", ["$event"]) public onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    // this.background = '#999';
  }
  @HostListener("dragleave", ["$event"]) public onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    // this.background = '#eee';
  }
  @HostListener("drop", ["$event"]) public onDrop(evt: DragEvent) {
    if (evt && evt.dataTransfer) {
      evt.preventDefault();
      evt.stopPropagation();
      // this.background = '#eee';
      const files: FileHandle[] = [];
      for (let i = 0; i < evt.dataTransfer.files.length; i++) {
        const file = evt.dataTransfer.files[i];
        const url = this.sanitizer.bypassSecurityTrustUrl(
          window.URL.createObjectURL(file),
        );
        files.push({
          file,
          url,
        });
      }
      if (files.length > 0) {
        this.files.emit(files);
      }
    }
  }
}
